import React, { useEffect, useState } from 'react'
import { connect } from "react-redux"
import TopBarNav from '../common/TopBarNav'
import { getMaintenanceDashboardIcon } from '../common/UtilsIcons'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardContent from '@material-ui/core/CardContent'
import Icon from 'antd/es/icon'
import { useHistory, Link as RouterLink } from 'react-router-dom'
import BreadcrumbsHistory from '../common/BreadcrumbsHistory'
import * as navigationActions from '../../actions/common/NavigationActions'
import { MaintenanceStyles } from './MaintenanceStyles'
import * as MaintenanceActions from "../../actions/maintenance/MaintenanceActions"
import { bindActionCreators } from 'redux'
import { Backdrop, CircularProgress } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

const MaintenanceDashboard = ({ classes, ...props }) => {
    const history = useHistory()
    const { match: { params } } = props;
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const { t } = useTranslation()

    useEffect(() => {
        handleOpenBackdrop()
        props.navigationActions.clean_routes()
        const newRoute = {
            path: '/maintenance',
            linkLegend: t('common.dashboard'),
            urlParams: [{ key: 'branchOfficeId', value: params.branchOfficeId }]
        }
        props.navigationActions.add_route(newRoute)
        props.actions.fetch_Dashboard(props.userLanguage, props.userToken, params.branchOfficeId, onError, onSuccess)
        return () => {
            props.cleanUserProfile()
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }
    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }
    const onSuccess = () => {
        handleCloseBackdrop()
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    console.log(err.response.data)
                    break
                default:
                    break
            }
        }
    }

    const handleIsDiasabled = (orderStatusId) => {
        switch (orderStatusId) {
            case 0: return false;
            case 3: return false;
            case 6: return false;
            case 20: return false;
            case 12: return false;
            case 15: return false;
            default: return true;
        }
    }

    const AdviceSuppliersBold = {
        marginTop: '-0.5em',
        marginBottom: '0.5em',
        color: 'green',
        fontSize: '17px',
        fontWeight: 'bold',        
    }

    const AdviceSuppliers = {
        marginTop: '-0.5em',
        marginBottom: '0.5em',
        color: 'green',
        fontSize: '17px'              
    }

    return (
        <div>
            <TopBarNav />
            <br />
            <BreadcrumbsHistory />
            <br />
            <Container maxWidth="lg" className={classes.root}>
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid container item xs={12} spacing={3} >
                    <Grid item xs={12} className={classes.dashboardAlign}>
                        <br />
                        <h5>Mantenimiento</h5>
                    </Grid>
                </Grid>                
                <Grid container spacing={1}>
                    <Grid container item xs={12} spacing={3}>
                        {
                            props.dashboardItems.map((itemDashboard, index) => {
                                return (
                                    <Grid item xs={4} key={index}>
                                        <Card className={classes.borderRadius}>
                                            <CardActionArea disabled={handleIsDiasabled(itemDashboard.orderStatusId)} component={RouterLink} to={`/maintenance/listByStatus/${itemDashboard.orderStatusId}&${params.branchOfficeId}`}>
                                                <CardHeader className={handleIsDiasabled(itemDashboard.orderStatusId) === true ? classes.cardHeaderDisabled : classes.cardHeader}
                                                    title={itemDashboard.statusName}
                                                    titleTypographyProps={{ variant: 'h6' }}
                                                />
                                                <CardContent className={classes.dashboardAlign}>
                                                    <Icon type={getMaintenanceDashboardIcon(itemDashboard.orderStatusId)} className={handleIsDiasabled(itemDashboard.orderStatusId) === true ? classes.dashboardIconDisabled : classes.dashboardIcon} theme="outlined" />
                                                    <br />
                                                    <br />
                                                    <Grid container item xs={12} spacing={3} className={classes.dashboardAlign}>
                                                        <br />
                                                        <Grid item xs={12} >
                                                            <Grid className={classes.subHeaderPadding}>
                                                                <br />
                                                                <Typography className={handleIsDiasabled(itemDashboard.orderStatusId) === true ? classes.textDisaled : classes.text}>Total</Typography>
                                                            </Grid>
                                                            <Grid className={classes.subHeaderPadding}>
                                                                <br />
                                                                <Typography className={handleIsDiasabled(itemDashboard.orderStatusId) === true ? classes.textDisaled : classes.text}>
                                                                    {
                                                                        handleIsDiasabled(itemDashboard.orderStatusId) === true ? 'N/A' : itemDashboard.total
                                                                    }
                                                                </Typography>
                                                                <br />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </CardActionArea>
                                        </Card>
                                    </Grid>
                                );
                            }
                            )
                        }
                    </Grid>
                    <Grid item xs={12}><br /></Grid>
                </Grid>
            </Container>
        </div>
    )
}

const mapStateToProps = state => ({
    dashboardItems: state.MaintenanceReducer.list,
    userProfile: state.UserProfileReducer.list,
    userlogin: state.LoginReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(MaintenanceActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(MaintenanceStyles)(MaintenanceDashboard))
